module.exports = __webpack_public_path__ + "media/images/icons/flags/CK-db76e67e69e4dfaee2b42164c10943da.svg";